"use strict";

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits.js").default;

var _createSuper = require("/app/node_modules/@babel/runtime/helpers/createSuper.js").default;

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.at.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

require("core-js/modules/es.error.cause.js");

require("core-js/modules/es.array.fill.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.slice.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHA2 = void 0;

var utils_js_1 = require("./utils.js"); // Polyfill for Safari 14


function setBigUint64(view, byteOffset, value, isLE) {
  if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);

  var _32n = BigInt(32);

  var _u32_max = BigInt(0xffffffff);

  var wh = Number(value >> _32n & _u32_max);
  var wl = Number(value & _u32_max);
  var h = isLE ? 4 : 0;
  var l = isLE ? 0 : 4;
  view.setUint32(byteOffset + h, wh, isLE);
  view.setUint32(byteOffset + l, wl, isLE);
} // Base SHA2 class (RFC 6234)


var SHA2 = /*#__PURE__*/function (_utils_js_1$Hash) {
  _inherits(SHA2, _utils_js_1$Hash);

  var _super = _createSuper(SHA2);

  function SHA2(blockLen, outputLen, padOffset, isLE) {
    var _this;

    _classCallCheck(this, SHA2);

    _this = _super.call(this);
    _this.blockLen = blockLen;
    _this.outputLen = outputLen;
    _this.padOffset = padOffset;
    _this.isLE = isLE;
    _this.finished = false;
    _this.length = 0;
    _this.pos = 0;
    _this.destroyed = false;
    _this.buffer = new Uint8Array(blockLen);
    _this.view = (0, utils_js_1.createView)(_this.buffer);
    return _this;
  }

  _createClass(SHA2, [{
    key: "update",
    value: function update(data) {
      if (this.destroyed) throw new Error('instance is destroyed');
      var view = this.view,
          buffer = this.buffer,
          blockLen = this.blockLen,
          finished = this.finished;
      if (finished) throw new Error('digest() was already called');
      data = (0, utils_js_1.toBytes)(data);
      var len = data.length;

      for (var pos = 0; pos < len;) {
        var take = Math.min(blockLen - this.pos, len - pos); // Fast path: we have at least one block in input, cast it to view and process

        if (take === blockLen) {
          var dataView = (0, utils_js_1.createView)(data);

          for (; blockLen <= len - pos; pos += blockLen) {
            this.process(dataView, pos);
          }

          continue;
        }

        buffer.set(data.subarray(pos, pos + take), this.pos);
        this.pos += take;
        pos += take;

        if (this.pos === blockLen) {
          this.process(view, 0);
          this.pos = 0;
        }
      }

      this.length += data.length;
      this.roundClean();
      return this;
    }
  }, {
    key: "digestInto",
    value: function digestInto(out) {
      if (this.destroyed) throw new Error('instance is destroyed');
      if (!(out instanceof Uint8Array) || out.length < this.outputLen) throw new Error('_Sha2: Invalid output buffer');
      if (this.finished) throw new Error('digest() was already called');
      this.finished = true; // Padding
      // We can avoid allocation of buffer for padding completely if it
      // was previously not allocated here. But it won't change performance.

      var buffer = this.buffer,
          view = this.view,
          blockLen = this.blockLen,
          isLE = this.isLE;
      var pos = this.pos; // append the bit '1' to the message

      buffer[pos++] = 128;
      this.buffer.subarray(pos).fill(0); // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again

      if (this.padOffset > blockLen - pos) {
        this.process(view, 0);
        pos = 0;
      } // Pad until full block byte with zeros


      for (var i = pos; i < blockLen; i++) {
        buffer[i] = 0;
      } // NOTE: sha512 requires length to be 128bit integer, but length in JS will overflow before that
      // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
      // So we just write lowest 64bit of that value.


      setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
      this.process(view, 0);
      var oview = (0, utils_js_1.createView)(out);
      this.get().forEach(function (v, i) {
        return oview.setUint32(4 * i, v, isLE);
      });
    }
  }, {
    key: "digest",
    value: function digest() {
      var buffer = this.buffer,
          outputLen = this.outputLen;
      this.digestInto(buffer);
      var res = buffer.slice(0, outputLen);
      this.destroy();
      return res;
    }
  }, {
    key: "_cloneInto",
    value: function _cloneInto(to) {
      var _to;

      to || (to = new this.constructor());

      (_to = to).set.apply(_to, _toConsumableArray(this.get()));

      var blockLen = this.blockLen,
          buffer = this.buffer,
          length = this.length,
          finished = this.finished,
          destroyed = this.destroyed,
          pos = this.pos;
      to.length = length;
      to.pos = pos;
      to.finished = finished;
      to.destroyed = destroyed;
      if (length % blockLen) to.buffer.set(buffer);
      return to;
    }
  }]);

  return SHA2;
}(utils_js_1.Hash);

exports.SHA2 = SHA2;